var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0227 0.859064L9.66916 1.21262L10.0227 0.859063C9.54396 0.380312 8.77273 0.380312 8.29398 0.859064L0.859064 8.29398C0.380312 8.77273 0.380313 9.54396 0.859063 10.0227L1.21262 9.66916L0.859064 10.0227L8.29398 17.4576C8.52631 17.69 8.84049 17.818 9.15567 17.818C9.4609 17.818 9.78023 17.702 10.0206 17.4544C10.4961 16.9754 10.495 16.2066 10.0174 15.7289L4.66624 10.3778H23.2544C23.9317 10.3778 24.4765 9.83298 24.4765 9.15567C24.4765 8.47352 23.9269 7.93892 23.2544 7.93892H4.67159L10.0227 2.5878C10.5015 2.10905 10.5015 1.33782 10.0227 0.859064Z",
    fill: "#00CEBC",
    stroke: "#00CEBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftOrder);
export default __webpack_public_path__ + "static/media/arrowLeftOrder.bd6a049a3cea304e41ab990915049f83.svg";
export { ForwardRef as ReactComponent };